import { useParams } from 'react-router-dom';

import RecipientsOverview from '../../features/recipients/layouts/overview';
import RecipientStats from '../../features/recipients/layouts/stats';

// TSS vite/01 §"Pages are thin". /admin/recipients (lista) · /admin/recipients/:id/stats (KPI).
export default function RecipientsPage() {
    const { id } = useParams();
    if (id) return <RecipientStats recipientId={id} />;
    return <RecipientsOverview />;
}
